import { c as _c } from "react/compiler-runtime";
import type { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';
import BrandVideo, { DialogProps } from './BrandVideo';
import css from './style/index.module.scss';
interface LinkProps {
  url: string;
}

/* eslint-disable react/jsx-no-target-blank */
// We want to send referrer headers for now
// We also want to have nofollow on the link, as advised by the SEO team
const BrandLink: FC<PropsWithChildren<LinkProps>> = t0 => {
  const $ = _c(4);
  const {
    url,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames(css["brand-seal"], css["quality-seal-link"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== url) {
    t2 = <a href={url} target="_blank" rel="noopener nofollow external" className={t1}>{children}</a>;
    $[1] = children;
    $[2] = url;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
/* eslint-enable react/jsx-no-target-blank */

const SealWrapper: FC<PropsWithChildren<DialogProps>> = t0 => {
  const $ = _c(9);
  const {
    videoId,
    url,
    name,
    children
  } = t0;
  if (videoId) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [css["brand-seal"]];
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== children || $[2] !== name || $[3] !== url || $[4] !== videoId) {
      t2 = <BrandVideo name={name} url={url} videoId={videoId} classes={t1}>{children}</BrandVideo>;
      $[1] = children;
      $[2] = name;
      $[3] = url;
      $[4] = videoId;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  } else {
    let t1;
    if ($[6] !== children || $[7] !== url) {
      t1 = <BrandLink url={url}>{children}</BrandLink>;
      $[6] = children;
      $[7] = url;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
};
const Logo: FC<{
  name: string;
  logo?: string;
}> = t0 => {
  const $ = _c(5);
  const {
    name,
    logo
  } = t0;
  if (logo) {
    const t1 = `/static/img/quality-seal/${logo}`;
    let t2;
    if ($[0] !== name || $[1] !== t1) {
      t2 = <img src={t1} alt={name} decoding="async" width="140" height="32" />;
      $[0] = name;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  } else {
    let t1;
    if ($[3] !== name) {
      t1 = <p className={css["quality-seal-name"]}>{name}</p>;
      $[3] = name;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
};
interface Props {
  qualitySeal: {
    id: string;
    name: string;
    brand: string;
    external_url: string;
    youtube_id?: string;
    logoName?: string;
  };
}
const QualitySeal = t0 => {
  const $ = _c(12);
  const {
    qualitySeal
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h6 className={classnames("headline-6", css["quality-seal-heading"])}>Incluso nel prezzo</h6>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <img className={css["check-icon"]} src="/static/img/quality-seal/check-circle.svg" width="24" height="24" alt="" loading="lazy" decoding="async" />;
    t3 = classnames("caption", "small", css["quality-seal-caption-text"]);
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <figcaption className={css["quality-seal-caption"]}>{t2}<span className={t3}>Certificato<br />di qualità</span></figcaption>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== qualitySeal.logoName || $[5] !== qualitySeal.name) {
    t5 = <Logo name={qualitySeal.name} logo={qualitySeal.logoName} />;
    $[4] = qualitySeal.logoName;
    $[5] = qualitySeal.name;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== qualitySeal.external_url || $[8] !== qualitySeal.name || $[9] !== qualitySeal.youtube_id || $[10] !== t5) {
    t6 = <>{t1}<figure className={css["quality-seal"]}>{t4}<SealWrapper videoId={qualitySeal.youtube_id} url={qualitySeal.external_url} name={qualitySeal.name}>{t5}</SealWrapper></figure></>;
    $[7] = qualitySeal.external_url;
    $[8] = qualitySeal.name;
    $[9] = qualitySeal.youtube_id;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default QualitySeal;